import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import '@/assets/styles/common.css'
import '@/assets/styles/ant-variables.css'
import App from './App.vue'
import router from '@/router/index'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { vTrim } from './directives/trim-directive'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.directive('trim', vTrim)

app.use(Antd)
app.use(pinia)
app.use(router)
app.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    navbar: true,
    toolbar: true,
    title: true,
  },
})
app.mount('#app')
